'use client';

import React, { useState } from 'react';
import queryString from 'query-string';
import format from 'date-fns/format';
import isDateValid from 'date-fns/isValid';
import parseISO from 'date-fns/parseISO';
import { Carousel } from '../../../../components/Carousel';
import { Link } from '../../../../components/Link';
import { SectionHeading } from '../../../../components/SectionHeading';
import { TruncatedTypography } from '../../../../components/TruncatedTypography';
import { Typography } from '../../../../components/Typography';
import { Scalable } from '../../../../components/Scalable';
import { ArticleRelatedArticle } from '../../../../types/api';
import { Camelize } from '../../../../types/camelize';
import desktopPlaceholder from '../../../../assets/images/wellness-articles/desktop-placeholder.jpg';
import mobilePlaceholder from '../../../../assets/images/wellness-articles/mobile-placeholder.jpg';
import { pxToNumber } from '../../../../wag-react/common/utils/pxToNumber';
import { Box } from '../../../../wag-react/next-components/box';
import { theme } from '../../../../wag-react/themes/base-theme';
import { Grid } from '../../../../wag-react/core-components/grid';
const swiperParams = {
  slidesPerView: 1.1,
  freeMode: true,
  loop: false,
  spaceBetween: 16,
  breakpoints: {
    [pxToNumber(theme.breakpoints[0])]: {
      slidesPerView: 2.1,
      spaceBetween: 24,
      freeMode: true
    },
    [pxToNumber(theme.breakpoints[1])]: {
      slidesPerView: 3.1,
      freeMode: true
    },
    [pxToNumber(theme.breakpoints[2])]: {
      slidesPerView: 4.1,
      freeMode: true
    }
  }
};
const formatDate = (date: string) => {
  const parseISODate = parseISO(date);
  if (!isDateValid(parseISODate)) {
    return '';
  }
  return format(parseISODate, 'MMM dd, yyyy').toUpperCase();
};
const defaultBannerImageQueryParams = {
  height: '328',
  fit: 'scale-down'
} as const;
export type WellnessArticleRelatedArticlesProps = {
  value: Camelize<ArticleRelatedArticle>[];
};
/**
 * @deprecated - Let's use `<ArticleRelatedArticles />` component
 */
export const WellnessArticleRelatedArticles = ({
  value
}: WellnessArticleRelatedArticlesProps) => {
  /**
   * To manage expensive computation, do it once
   */
  const [newRelatedArticleItems] = useState(() => value.map(item => ({
    ...item,
    bannerImage: item.bannerImage ? [queryString.stringifyUrl({
      url: item.bannerImage,
      query: {
        ...defaultBannerImageQueryParams,
        width: '200'
      }
    }), null, queryString.stringifyUrl({
      url: item.bannerImage,
      query: {
        ...defaultBannerImageQueryParams,
        width: '344'
      }
    })] : [mobilePlaceholder, null, desktopPlaceholder]
  })).map(item => ({
    ...item,
    bannerImage: item.bannerImage.map(bannerImage => bannerImage ? `url(${bannerImage})` : bannerImage)
  })));
  return <Box m="0 auto" data-sentry-element="Box" data-sentry-component="WellnessArticleRelatedArticles" data-sentry-source-file="index.tsx">
      <SectionHeading fontSize="26px" color="#474747" my="30px" data-sentry-element="SectionHeading" data-sentry-source-file="index.tsx">
        You may also like
      </SectionHeading>
      <Carousel keyExtractor={(item: ArticleRelatedArticle) => item.title} navigation={false} value={newRelatedArticleItems} px="0" swiperParams={swiperParams} data-sentry-element="Carousel" data-sentry-source-file="index.tsx">
        {(item: Camelize<ArticleRelatedArticle>) => <Link href={item.src} target="_blank" height="328px" width={['200px', '344px']}>
            <Scalable height="328px" borderRadius="8px">
              <Box backgroundImage={item.bannerImage} backgroundPosition="center" backgroundSize="cover" backgroundRepeat="no-repeat" height="232px" />
              <Box height="150px" p="16px" mt="-80px" backgroundColor="white" borderRadius="8px" mx="16px">
                <Grid gridTemplateRows="72px 36px" textAlign="center">
                  <Box>
                    <TruncatedTypography fontSize="18px" fontFamily="muliBold" color="#474747" my="8px" lineClamp={3} text={item.title} hover />
                  </Box>
                  {item.createdAt && item.readTime && <Typography variant="legal" hover>
                      {`${formatDate(item.createdAt)} | ${item.readTime.text}`}
                    </Typography>}
                </Grid>
              </Box>
            </Scalable>
          </Link>}
      </Carousel>
    </Box>;
};